import * as moment from 'moment';

export const sortByProperty = (field, reverse, primer) => {
  const key = primer
    ? function (x) {
        return primer(x[field]);
      }
    : function (x) {
        return x[field];
      };

  reverse = !reverse ? 1 : -1;

  return function (a, b) {
    return (a = key(a)), (b = key(b)), reverse * ((a > b) - (b > a));
  };
};

export const findBySearchString = (key, searchString, itemArray) => {
  let results = [];
  itemArray.forEach((element) => {
    if (element[key].toLowerCase().indexOf(searchString.toLowerCase()) !== -1) {
      results.push(element);
    }
  });
  return results;
};

export const formatCustomCSSClasses = (customCSSClasses) => {
  let projectCustomCSSClassesData = '';
  customCSSClasses.forEach((element) => {
    if (element.classProperty) {
      const classWithProp = JSON.stringify(element.classProperty);
      const unquotedClassWithProp = classWithProp.replace(/"([^"]+)"/g, '$1').replaceAll(',', ';');
      projectCustomCSSClassesData += `${
        element.class.startsWith('.') ? element.class : '.' + element.class
      }${element.pseudoClass ? ':' + element.pseudoClass : ''}${unquotedClassWithProp} `;
    }
  });

  return projectCustomCSSClassesData;
};
